import { render, staticRenderFns } from "./WindowRanking.vue?vue&type=template&id=58f37152&scoped=true"
import script from "./WindowRanking.vue?vue&type=script&lang=js"
export * from "./WindowRanking.vue?vue&type=script&lang=js"
import style0 from "./WindowRanking.vue?vue&type=style&index=0&id=58f37152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f37152",
  null
  
)

export default component.exports